import { Form, Input, InputNumber, Switch } from '@arco-design/web-react'
import SettingSectionCard from '../SettingSectionCard'
import type { OptionsAPI } from '../useOptions'

const KEYS = [
  'monitor_setting.auto_test_channel_enabled',
  'monitor_setting.auto_test_channel_minutes',
  'ChannelDisableThreshold',
  'QuotaRemindThreshold',
  'AutomaticDisableChannelEnabled',
  'AutomaticEnableChannelEnabled',
  'AutomaticDisableStatusCodes',
  'AutomaticRetryStatusCodes',
  'AutomaticDisableKeywords',
]

export default function MonitoringSection({ options }: { options: OptionsAPI }) {
  const { get, getBool, getNumber, patch } = options

  return (
    <SettingSectionCard title="监控设置" subtitle="通道自动测试、禁用与重试策略" keys={KEYS} options={options}>
      <Form layout="vertical">
        <div className="grid md:grid-cols-2 gap-3">
          <Form.Item label="定时测试所有通道">
            <Switch
              checked={getBool('monitor_setting.auto_test_channel_enabled')}
              onChange={(v) => patch({ 'monitor_setting.auto_test_channel_enabled': v })}
            />
          </Form.Item>
          <Form.Item label="自动测试间隔（分钟）">
            <InputNumber
              style={{ width: '100%' }}
              min={1}
              value={getNumber('monitor_setting.auto_test_channel_minutes', 10)}
              onChange={(v) => patch({ 'monitor_setting.auto_test_channel_minutes': v ?? 10 })}
            />
          </Form.Item>
          <Form.Item label="通道最长响应时间（秒）" extra="全量测试超过此时间将自动禁用">
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              value={getNumber('ChannelDisableThreshold')}
              onChange={(v) => patch({ ChannelDisableThreshold: v ?? 0 })}
            />
          </Form.Item>
          <Form.Item label="额度提醒阈值（Token）" extra="低于此额度发邮件提醒">
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              value={getNumber('QuotaRemindThreshold')}
              onChange={(v) => patch({ QuotaRemindThreshold: v ?? 0 })}
            />
          </Form.Item>
          <Form.Item label="失败时自动禁用通道">
            <Switch
              checked={getBool('AutomaticDisableChannelEnabled')}
              onChange={(v) => patch({ AutomaticDisableChannelEnabled: v })}
            />
          </Form.Item>
          <Form.Item label="成功时自动启用通道">
            <Switch
              checked={getBool('AutomaticEnableChannelEnabled')}
              onChange={(v) => patch({ AutomaticEnableChannelEnabled: v })}
            />
          </Form.Item>
          <Form.Item label="自动禁用状态码" extra="逗号分隔，支持范围如 500-599">
            <Input value={get('AutomaticDisableStatusCodes', '401')} onChange={(v) => patch({ AutomaticDisableStatusCodes: v })} />
          </Form.Item>
          <Form.Item label="自动重试状态码" extra="504/524 始终不重试">
            <Input
              value={get('AutomaticRetryStatusCodes', '100-199,300-399,401-407,409-499,500-503,505-523,525-599')}
              onChange={(v) => patch({ AutomaticRetryStatusCodes: v })}
            />
          </Form.Item>
        </div>
        <Form.Item label="自动禁用关键词" extra="一行一个，错误信息包含则禁用通道">
          <Input.TextArea
            value={get('AutomaticDisableKeywords')}
            onChange={(v) => patch({ AutomaticDisableKeywords: v })}
            autoSize={{ minRows: 4, maxRows: 10 }}
          />
        </Form.Item>
      </Form>
    </SettingSectionCard>
  )
}
